import { Injectable } from '@angular/core';
import { FusionAuthService, UserInfo } from '@fusionauth/angular-sdk';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  public ROLE_VIEW_READONLY: string = 'view.readonly';
  public ROLE_VIEW_BOUTIQUE: string = 'view.boutique';
  public ROLE_VIEW_COMMUNITY_SHOP: string = 'view.community_shop';
  public ROLE_MANAGE_ADMIN: string = 'manage.admin';

  constructor(private fusionAuth: FusionAuthService) {
    this.getUserInfo();
  }

  //@ts-ignore
  user: Subject<UserInfo> = new BehaviorSubject<UserInfo>(null);
  roles: string[] = [];

  hasRole(role: string) {
    return this.roles.indexOf(role) > -1;
  }

  async getUserInfo() {
    this.user.next(await this.fusionAuth.getUserInfo());
    this.roles = this.user.getValue().roles;
  }

  async getUser() {
    return this.user;
  }

  isAdmin() {
    return this.roles.indexOf(this.ROLE_MANAGE_ADMIN) > -1;
  }

  logout() {
    this.fusionAuth.logout();
  }
}
